import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-image-gallery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageGalleryComponent {
  @Input() images: any[] = [];
  @Output() openFullscreen = new EventEmitter<number>();
  @ViewChild('thumbScroll') thumbScroll!: ElementRef<HTMLDivElement>;
  @ViewChildren('galleryVideo') galleryVideos!: QueryList<ElementRef<HTMLVideoElement>>;

  // Using signal for better reactivity
  currentIndex = 0;

  scrollThumbs(direction: 'left' | 'right') {
    if (this.thumbScroll && this.thumbScroll.nativeElement) {
      const container = this.thumbScroll.nativeElement;
      const scrollAmount = 250;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  }

  next() {
    if (this.images.length > 0 && this.currentIndex < this.images.length - 1) {
      this.pauseAllVideos();
      this.currentIndex++;
    }
  }

  prev() {
    if (this.images.length > 0 && this.currentIndex > 0) {
      this.pauseAllVideos();
      this.currentIndex--;
    }
  }

  goTo(index: number) {
    if (index >= 0 && index < this.images.length) {
      this.pauseAllVideos();
      this.currentIndex = index;
    }
  }

  togglePlay(event: MouseEvent, video: HTMLVideoElement): void {
    event.stopPropagation();
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  private pauseAllVideos(): void {
    if (this.galleryVideos) {
      this.galleryVideos.forEach((v) => {
        if (!v.nativeElement.paused) v.nativeElement.pause();
      });
    }
  }

  onImageClick(): void {
    this.openFullscreen.emit(this.currentIndex);
  }

  onThumbClick(index: number): void {
    this.currentIndex = index;
    this.openFullscreen.emit(index);
  }

  getMimeType(img: any): string {
    const url = img?.url?.toLowerCase() || '';
    if (url.endsWith('.mov')) return 'video/quicktime';
    return 'video/mp4';
  }
}
